module.exports = __webpack_public_path__ + "img/project19_3.png.ef5815f8.webp";